<template>
  <Upload
    ref="upload"
    class="upload-style"
    :action="uploadUrl"
    :headers="headers"
    v-bind="$attrs"
  >
    <Button >上传</Button>
  </Upload>
</template>
<script>
import { uploadA } from "@/server/api";
import { getToken } from '@/utils/auth'

export default {
  props: {
    filepath: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      uploadUrl: uploadA,
      headers: { Authorization: getToken() },
    };
  },
  methods: {
    clearFiles() {
      this.$refs.upload.clearFiles();
    }
  }
};
</script>